import { createFileRoute, Link } from '@tanstack/react-router';
import { FiEdit3 } from 'react-icons/fi';

export const Route = createFileRoute('/mail/')({
  component: MailIndexPage,
});

function MailIndexPage() {
  return (
    <div className="flex-1 flex flex-col rounded-none md:rounded-[16px] border-0 md:border border-[#262626] bg-[#0E0E0E] items-center justify-center text-center px-5 md:px-8 relative overflow-hidden">
      {/* Premium background radial glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[280px] md:w-[350px] h-[280px] md:h-[350px] rounded-full bg-[#2F80ED]/5 blur-[80px] pointer-events-none" />

      {/* Styled card graphic */}
      <div className="relative mb-8 md:mb-12 flex-shrink-0">
        <div className="w-[130px] md:w-[160px] h-[82px] md:h-[100px] rounded-2xl bg-gradient-to-b from-[#18181b] to-[#09090b] border border-[#27272a] p-3 md:p-4 flex flex-col gap-2 md:gap-2.5 shadow-2xl relative">
          <div className="w-[45%] h-1.5 md:h-2 rounded bg-white/[0.06]" />
          <div className="w-[70%] h-1.5 md:h-2 rounded bg-white/[0.06]" />
          <div className="w-[55%] h-1.5 md:h-2 rounded bg-white/[0.06]" />
        </div>

        {/* Floating @ badge overlapping card bottom border */}
        <div className="absolute -bottom-4 md:-bottom-5 left-1/2 -translate-x-1/2">
          <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-gradient-to-br from-[#2F80ED] to-[#1a5bb5] border-4 border-[#0E0E0E] flex items-center justify-center text-white text-sm md:text-base font-bold shadow-[0_0_25px_rgba(47,128,237,0.35)] select-none">
            @
          </div>
        </div>
      </div>

      <h2 className="text-base md:text-lg font-bold text-white mb-2 tracking-tight">
        Your audience is waiting
      </h2>
      <p className="text-xs md:text-sm text-[#737373] max-w-sm mb-6 md:mb-8 leading-relaxed px-2">
        Send updates, booking requests, lineup announcements, and event reminders
      </p>

      <Link
        to="/mail/compose"
        className="flex items-center gap-2 md:gap-2.5 px-5 md:px-6 py-2.5 md:py-3 rounded-full bg-white text-black text-xs md:text-sm font-semibold hover:bg-gray-100 transition-all duration-200 shadow-[0_0_30px_rgba(255,255,255,0.08)] group"
        style={{ color: '#000000' }}
      >
        <FiEdit3
          size={14}
          className="md:hidden group-hover:scale-105 transition-transform"
          style={{ color: '#000000' }}
        />
        <FiEdit3
          size={15}
          className="hidden md:block group-hover:scale-105 transition-transform"
          style={{ color: '#000000' }}
        />
        Start Writing
      </Link>
    </div>
  );
}
